import React from 'react'
import { observer } from 'mobx-react'
import { IS_BROWSER } from 'src/utils/application'
import { ApiContent } from 'src/utils/getDataFromTree'
import {
  getContextStackPageEntries,
  getContentStackEntries,
} from 'src/utils/contentStackUtils'
import { enableNewFeature } from 'src/utils'
import { contentStackContainer } from 'src/models'
import { MicroFrontendLoader } from 'src/views/components/MicroFrontends/MicroFrontendLoader'
import { buildMfeLoaderId } from 'src/views/components/MicroFrontends/MicroFrontendUtils'

@observer
class ContentStackPage extends React.Component {
  static contextType = ApiContent

  constructor(props, context) {
    super(props, context)
    this.context = context
    this.contextName = 'csPageEntry'
  }

  getUrlWithLocale = () => {
    // On CSR: location.pathname includes locale (e.g., /in/en/contact-us)
    if (IS_BROWSER) {
      return this.props?.location?.pathname || ''
    }

    // On SSR: get originalUrl from StaticRouter context, which includes locale
    // StaticRouter stores this in routeProps.staticContext.originalUrl
    const originalUrl =
      this.props?.staticContext?.originalUrl ||
      this.context?.mfeApp?.params?.url ||
      this.props?.location?.pathname ||
      ''

    return originalUrl
  }

  render() {
    const { entries: propsEntries } = this.props
    const { contentStackPage } = contentStackContainer
    const contextPageEntry = (this.csPageEntry =
      this.context?.[this.contextName]?.entries ??
      this.context?.ssrData?.[this.contextName]?.entries)

    const entries = getContentStackEntries({
      contextPageEntry,
      contentStackPage,
    })

    if (IS_BROWSER && contentStackPage?.isLoading && !contextPageEntry) {
      return null
    }

    const microFrontends =
      entries?.microFrontend || propsEntries?.microFrontend || []

    const forceVBRendering = enableNewFeature('enableForceVBRendering')

    // When enableForceVBRendering is false and no microFrontend entries exist, render nothing
    if (!forceVBRendering && microFrontends.length === 0) {
      return null
    }

    const urlWithLocale = this.getUrlWithLocale()
    const { onPageNotFound } = this.props

    return (
      <div className="content-stack-page">
        {microFrontends.map((mfe, index) => {
          const remoteConfig = {
            appName: mfe?.microFrontend?.microfrontendApp,
            component: mfe?.microFrontend?.microFrontendComponent || 'App',
          }
          /**
           * Derive the React key from app identity (app name + component + slot
           * index) rather than slot index alone. MicroFrontendLoader picks its
           * app only when it mounts, so when the entries for a slot switch to a
           * different MFE (for example on Back navigation), the new key forces
           * React to unmount the stale loader and mount a fresh one instead of
           * keeping the previous app mounted.
           */
          const loaderId = buildMfeLoaderId({
            index,
            appName: remoteConfig.appName,
            component: remoteConfig.component,
          })
          return remoteConfig.appName ? (
            <MicroFrontendLoader
              key={loaderId}
              loaderId={loaderId}
              remoteConfig={remoteConfig}
              params={{
                url: urlWithLocale,
                csEntry: entries,
              }}
              isToEnableSSR={mfe?.microFrontend?.enableServerRendering || false}
              onPageNotFound={onPageNotFound}
            />
          ) : null
        })}
      </div>
    )
  }
}

export { ContentStackPage }
export default ContentStackPage
